import { module } from 'modujs';
import { $html } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            focusin: 'onFocus'
        }
    }

    onFocus(e) {     
        // ONLY LISTEN FOR FOCUS-VISIBLE EVENT
        if(window.getComputedStyle(e.target).getPropertyValue('--has-focus-visible') != 'true') return;

        this.call('scrollTo', { target: this.el, immediate: true }, 'Scroll')
        this.call('scrollTo', { target: e.target, immediate: true }, 'Scroll')        
    }        

    onScrollProgress(progress) {
        $html.classList.toggle('has-footer-inview', progress > 0.5);

        this.el.style.setProperty('--progress', progress);
    }

    destroy() {
        $html.classList.remove('has-footer-inview');
    }
}
